export default "__VITE_ASSET__6zHP64tN__"